import {Link} from '#component/base';

import {AnchorProps} from '../Markdown.types';

export const Anchor = ({children, href}: AnchorProps) => {
  return <Link href={href}>{children}</Link>;
};
